export { default } from './CalloutRight';
